/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import './Program.css';

const trackColors = {
    slot1: 'track1-color',
    slot2: 'track2-color',
    slot3: 'track3-color',
    slot4: 'track4-color',
    slot5: 'track5-color',
    slot6: 'track6-color',
    workshop: 'workshop-color'
};

const trackInSlot = {
    slot1: 'Innovations',
    slot2: 'Security',
    slot3: 'Digital Transformation',
    slot4: 'Interfaces',
    slot5: 'Data',
    slot6: 'Code & Talks',
    workshop: 'Hands-on Lab'
};

const ProgramCard = ({
    id,
    track,
    time,
    room,
    speakers,
    tileRole,
    talks,
    onClickHandler,
    screen
}) => {
    const roomString = room || '';
    return (
        <div
            className={`column is-desktop ${
                screen === 'program' ? 'is-full-touch' : 'is-6-desktop is-12-mobile is-6-tablet'
            }`}
            id="program-card"
        >
            <div
                className={`card ${
                    talks.length === 0 && tileRole !== 'KEYNOTE STREAM' ? 'not-clickable' : ''
                } ${tileRole === 'CLOSED' ? 'closed' : ''}`}
                onClick={
                    talks.length > 0 || tileRole === 'KEYNOTE STREAM'
                        ? onClickHandler(id)
                        : undefined
                }
            >
                <div className="card-content">
                    {talks.length > 0 ? (
                        talks.map((talk, index) => (
                            <div className="program-talk-info-wrapper" key={talk.title}>
                                <p className="program-card-top-row">
                                    <span className="is-full-desktop">
                                        {talk.title || tileRole}
                                    </span>
                                    <span
                                        className={`is-hidden-desktop ${
                                            index > 0 ? 'is-hidden' : ''
                                        }`}
                                    >
                                        &nbsp;{time}
                                    </span>
                                </p>
                                <p className="program-card-speakers">
                                    <span className="speakers">
                                        {Object.keys(speakers).length > 0
                                            ? speakers[talk.id].join(', ')
                                            : ''}
                                    </span>
                                    {talk.youtube ? (
                                        <a
                                            href={talk.youtube}
                                            id="video-link"
                                            rel="noopener noreferrer"
                                            target="_blank"
                                        >
                                            <i
                                                className="fab fa-youtube-square fa-2x video"
                                                id="video-link"
                                            />
                                        </a>
                                    ) : null}
                                </p>
                            </div>
                        ))
                    ) : (
                        <div className="program-talk-info-wrapper" key={tileRole}>
                            <p className="program-card-top-row">
                                <span className="is-full-desktop">{tileRole}</span>
                                <span className="is-hidden-desktop">&nbsp;{time}</span>
                            </p>
                        </div>
                    )}

                    <div className="program-card-track-row">
                        {track ? (
                            <i className={`fas fa-circle ${track && trackColors[track]}`} />
                        ) : null}
                        <span className={track ? 'track' : ''}>
                            {track ? `${trackInSlot[track]} - ${roomString}` : `${roomString}`}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

ProgramCard.defaultProps = {
    track: ''
};

ProgramCard.propTypes = {
    id: PropTypes.string.isRequired,
    onClickHandler: PropTypes.func.isRequired,
    room: PropTypes.string.isRequired,
    screen: PropTypes.string.isRequired,
    speakers: PropTypes.objectOf(PropTypes.any).isRequired,
    talks: PropTypes.arrayOf(PropTypes.object).isRequired,
    tileRole: PropTypes.string.isRequired,
    time: PropTypes.string.isRequired,
    track: PropTypes.string
};

export default ProgramCard;
